import { IActivityHistoryItem } from "../../domain/model";
import { InjectAsyncHistoryItemsPayload } from "./request";

export const validateAddAsyncCommand = (payload: InjectAsyncHistoryItemsPayload, items: IActivityHistoryItem[]) => {
    if(!payload.filters)
        throw new Error("filters is required");
    if(payload.entityId !== payload.filters.id)
        throw new Error("entityId and filters.id must be the same");
    if(!payload.filters.title)
        throw new Error("filters.title is required");
    if(!payload.asyncDataProvider)
        throw new Error("asyncDataProvider is required");
    if(!payload.componentFactory)
        throw new Error("componentFactory is required");
    if(!payload.errorMessage)
        throw new Error("errorMessage is required for failure asyncDataProviders");
    if(items === null || items === undefined)
        throw new Error("items is required");
    if(!Array.isArray(items))
        throw new Error("items must be an array");
};